import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const LandingPage = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" fill="none">
        <path
          d="M5.92554 5.12275C5.83175 4.34845 6.43615 3.66643 7.21611 3.66643H24.1247C24.9123 3.66643 25.519 4.36125 25.4128 5.14167L22.5418 26.2451C22.4541 26.8895 21.9039 27.3699 21.2537 27.3699H9.77236C9.11485 27.3699 8.56086 26.879 8.48179 26.2262L5.92554 5.12275Z"
          fill="#F655DD"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M9.07498 10.193C9.05071 10.013 9.19067 9.85295 9.37229 9.85295H21.9088C22.0848 9.85295 22.223 10.0037 22.2077 10.1791L21.8824 13.9027C21.8688 14.0577 21.7391 14.1766 21.5835 14.1766H9.87424C9.72405 14.1766 9.597 14.0655 9.57693 13.9167L9.07498 10.193Z"
          fill="#FFDB59"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.3249 7.55492C22.7115 7.55492 23.0249 7.24152 23.0249 6.85492C23.0249 6.46833 22.7115 6.15492 22.3249 6.15492L20.7701 6.15492C20.3835 6.15492 20.0701 6.46833 20.0701 6.85492C20.0701 7.24152 20.3835 7.55492 20.7701 7.55492L22.3249 7.55492ZM22.2 20.5081C22.2 20.8947 21.8866 21.2081 21.5 21.2081L10 21.2081C9.6134 21.2081 9.3 20.8947 9.3 20.5081C9.3 20.1215 9.6134 19.8081 10 19.8081L21.5 19.8081C21.8866 19.8081 22.2 20.1215 22.2 20.5081ZM15.2 23.6692C15.2 24.0558 14.8866 24.3692 14.5 24.3692L10.5 24.3692C10.1134 24.3692 9.80001 24.0558 9.80001 23.6692C9.80001 23.2826 10.1134 22.9692 10.5 22.9692L14.5 22.9692C14.8866 22.9692 15.2 23.2826 15.2 23.6692ZM21.5 18.2043C21.8866 18.2043 22.2 17.8909 22.2 17.5043C22.2 17.1177 21.8866 16.8043 21.5 16.8043L9.49999 16.8043C9.11339 16.8043 8.79999 17.1177 8.79999 17.5043C8.79999 17.8909 9.11339 18.2043 9.49999 18.2043L21.5 18.2043ZM10.165 6.85506C10.165 7.24166 9.85157 7.55506 9.46497 7.55506L8.98299 7.55506C8.59639 7.55506 8.28299 7.24166 8.28299 6.85506C8.28299 6.46846 8.59639 6.15506 8.98299 6.15506L9.46497 6.15506C9.85157 6.15506 10.165 6.46846 10.165 6.85506ZM19.3416 6.85492C19.3416 7.24152 19.0282 7.55492 18.6416 7.55492L17.0868 7.55492C16.7002 7.55492 16.3868 7.24152 16.3868 6.85492C16.3868 6.46833 16.7002 6.15492 17.0868 6.15492L18.6416 6.15492C19.0282 6.15492 19.3416 6.46833 19.3416 6.85492ZM14.9941 7.55478C15.3807 7.55478 15.6941 7.24138 15.6941 6.85478C15.6941 6.46819 15.3807 6.15478 14.9941 6.15478L13.4393 6.15478C13.0527 6.15478 12.7393 6.46819 12.7393 6.85478C12.7393 7.24138 13.0527 7.55478 13.4393 7.55478L14.9941 7.55478Z"
          fill="#2B2F38"
        />
        <path
          d="M15.6141 12.9624L18.3209 25.6365L21.149 22.6841L23.9569 26.2346L27.0855 23.3821L24.1799 20.1277L27.5226 17.585L15.6141 12.9624Z"
          fill="white"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default LandingPage
